export enum OinTypeEnum {
  REGULAR = 'REGULAR',
  FINAL = 'FINAL',
  PREPAYMENT = 'PREPAYMENT',
}
